<template>
  <el-dialog
    :title="$t('输入6位验证码')"
    :visible.sync="vis"
    :custom-class="currentLangType() === 'en' ? 'dialog_six' : ''"
    width="420px"
    top="130px"
    :modal="false"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <p class="input_tips">{{ $t('验证码已发送至') }}{{ dataList.username }}</p>
    <div class="verify_input_box">
      <VerifyInput :code="validationCode" @input="handleInput"></VerifyInput>
    </div>
    <div class="btn_box">
      <el-button
        :loading="confirmLoading"
        type="primary"
        @click="handleCommit()"
        :disabled="disabledBtn"
      >
        {{ btnText }}
      </el-button>
    </div>
    <p class="code_send">
      {{ $t('验证码已发送') }}？
      <span v-if="canSendCode" class="is_link" @click="handleSendCode()">
        {{ $t('重发') }}
      </span>
      <span v-else class="count_down">
        {{ $t('秒后重新发送', { num: timeCountDown }) }}
      </span>
    </p>
  </el-dialog>
</template>
<script>
import ModalBase from '@/components/ModalBase'
import getCode from './../mixin/getCode'
import currentLangType from '@/utils/currentLangType'
import { userRegister, doCheckCaptcha, forgetPassword } from '@/api/sign'
export default {
  name: 'SixValidation',
  extends: ModalBase,
  props: {
    dataList: Object,
    type: String
  },
  mixins: [getCode],
  data() {
    return {
      confirmLoading: false,
      disabledBtn: true,
      validationCode: [],
      codeString: '',
      canSendCode: false, // 初始默认不能发送验证码
      timer: null, // 倒计时定时器
      timeCountDown: 60
    }
  },
  computed: {
    btnText() {
      return {
        register: this.$t('注册'),
        forgetPassword: this.$t('提交')
      }[this.type]
    }
  },
  watch: {
    vis(newVal, oldVal) {
      if (newVal) this.dealCountDown()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    currentLangType,
    dealCountDown() {
      this.timer = setInterval(() => {
        if (this.timeCountDown === 0) {
          clearInterval(this.timer)
          this.canSendCode = true
          this.timeCountDown = 60
        } else {
          this.canSendCode = false
          this.timeCountDown--
        }
      }, 1000)
    },
    handleInput(array) {
      if (array.length < 6) {
        this.disabledBtn = true
      } else {
        let resultString = ''
        for (let i = 0; i < array.length; i++) {
          resultString = resultString + array[i]
        }
        this.validationCode = array
        this.codeString = resultString
        this.disabledBtn = false
      }
    },

    async handleCommit() {
      this.confirmLoading = true
      try {
        const { certificate } = await doCheckCaptcha({
          account: this.dataList.account,
          type: this.type,
          code: this.codeString
        })
        const { passwordAgain, ...params } = this.dataList
        const api = {
          register: userRegister,
          forgetPassword
        }[this.type]
        await api({ ...params, certificate })
        this.$Message.success({
          content: this.$t('操作成功'),
          duration: 0.8,
          onClose: () => {
            this.vis = false
            this.confirmLoading = false
            this.validationCode = []
            this.$router.replace({ path: '/signin' })
          }
        })
      } catch {
        this.confirmLoading = false
        this.validationCode = []
      }
    },
    // 重发验证码
    handleSendCode() {
      this.getCaptcha({
        account: this.dataList.account,
        areaCode: this.dataList.areaCode,
        type: 'register'
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  border-radius: 20px;
  .el-dialog__header {
    padding: 38px 40px 0 40px;
    .el-dialog__title {
      display: inline-block;
      height: 42px;
      font-size: 30px;
      font-weight: 500;
      font-family: PingFangSC-Medium, 'PingFang SC';
      color: rgba(51, 51, 51, 1);
      line-height: 42px;
    }
  }
  .el-dialog__body {
    padding: 40px;
    .input_tips {
      height: 25px;
      font-size: 18px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 25px;
    }
    .verify_input_box {
      margin-top: 30px;
    }
    .btn_box {
      margin-top: 40px;
      .element_button_mixin(
        @padding: 8px 20px,
        @width: 100%,
        @fontSize: 18px,
        @lineHeight: 22px
      );
    }
    .code_send {
      margin-top: 20px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, 'PingFang SC';
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
      .count_down {
        color: rgba(153, 153, 153, 1);
      }
    }
  }
}

// 语言为英语时，进行样式微调
/deep/ .dialog_six {
  .el-dialog__header {
    .el-dialog__title {
      font-size: 23px;
    }
  }
  .el-dialog__body {
    .input_tips {
      font-size: 15px;
    }
  }
}
</style>
